import React from "react";
import TrailTable from "components/common/TrailTable/TrailTable";

interface Props {
  entityId: string | number;
}

export const AppsTrailTab: React.FC<Props> = ({ entityId }) => {
  return (
    <TrailTable entityType="footerApplications" entityId={Number(entityId)} />
  );
};
